import React, { useEffect, useMemo, useState } from 'react';
import { useTiktokShop } from '@/tiktok-platform/context/TiktokShopContext';
import PlatformShopDimensionTabs from '@/components/platform/PlatformShopDimensionTabs';
import {
  PLATFORM_ALL_SHOPS_ID,
  isAllShopsScope,
  isConcreteShopId,
  resolveConcreteShopId,
} from '@/utils/platformShopScope';

/**
 * TikTok 页内店铺维度：跟随顶栏 activeShopId，可临时收窄/切到全部（不回写顶栏）。
 */
export function useTiktokPageShopScope() {
  const shopCtx = useTiktokShop();
  const {
    activeShopId,
    scopedShops = [],
    expectedShopType,
    isAllShopsMode,
  } = shopCtx;

  const [pageShopScope, setPageShopScope] = useState(() => activeShopId || '');

  useEffect(() => {
    setPageShopScope(activeShopId || '');
  }, [activeShopId]);

  const concreteScopeId = resolveConcreteShopId(pageShopScope);
  const allShopsScope = isAllShopsScope(pageShopScope);
  const listReady = Boolean(pageShopScope)
    && (isConcreteShopId(pageShopScope) || (allShopsScope && expectedShopType));

  // 仅门禁选「全部」进入时展示页内店铺维度；单店登录不应再切换店铺
  const shopDimensionTabs = useMemo(() => {
    if (!isAllShopsMode || !scopedShops.length) return null;
    return (
      <PlatformShopDimensionTabs
        shops={scopedShops}
        value={pageShopScope || PLATFORM_ALL_SHOPS_ID}
        onChange={setPageShopScope}
        showAll={scopedShops.length >= 2}
        ariaLabel="店铺维度"
      />
    );
  }, [isAllShopsMode, scopedShops, pageShopScope]);

  return {
    ...shopCtx,
    pageShopScope,
    setPageShopScope,
    concreteScopeId,
    allShopsScope,
    listReady,
    shopDimensionTabs,
  };
}

export function stackShopDimensionTabs(shopDimensionTabs, statusTabs) {
  if (!shopDimensionTabs && !statusTabs) return null;
  if (!shopDimensionTabs) return statusTabs;
  if (!statusTabs) return shopDimensionTabs;
  return (
    <>
      {shopDimensionTabs}
      {statusTabs}
    </>
  );
}
